/** @jsxImportSource @emotion/core */
import React, { FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { MdBusiness, MdSchool, MdBook } from 'react-icons/md';

import { Grid } from 'components/styled';
import { ResponsivePadder } from 'components/styled/Wrapper';
import Text from 'components/styled/Text';

import Store from 'utils/Store';

import { OffscreenCSS } from 'theme/GlobalStyles';

import LoginBox from './LoginBox';

type Props = {
	externalState?: { redirect: string };
	offerVariant?: boolean;
};
const LoginOptions: FC<Props> = ({ externalState, offerVariant }) => {
	const { push } = useHistory();
	const { state } = useLocation();

	useEffect(() => {
		if (externalState) {
			Store.set('vsb-student-redirect', JSON.stringify(externalState));
		}
	}, [externalState]);

	const color = offerVariant ? 'black' : undefined;

	return (
		<ResponsivePadder
			width={1}
			mt={[3, 4]}
			mb={[3, 4]}
			flexGrow={1}
			zIndex={1}
			justifyContent="flex-end"
		>
			<Text as="h2" css={OffscreenCSS}>
				Vítejte na oficiálním kariérním portálu VŠB - TUO
			</Text>

			<Grid gridTemplateColumns={['1fr', '1fr 1fr 1fr']} alignSelf="center">
				<LoginBox
					icon={MdBook}
					onLogin={() => window.location.replace('/api/login/cas')}
					onRegister={() => window.location.replace('/api/login/cas')}
					redirectUrl="how-it-works/student"
				>
					<Text m={0} as="span" color={color}>
						Jsem{' '}
						<Text fontWeight="bold" as="span">
							Student
						</Text>
					</Text>
				</LoginBox>

				<LoginBox
					icon={MdSchool}
					onLogin={() =>
						push({
							pathname: '/login/absolvent',
							state: externalState ?? state,
						})
					}
					onRegister={() => push('/registration/absolvent')}
					redirectUrl="how-it-works/absolvent"
				>
					<Text m={0} as="span" color={color}>
						Jsem{' '}
						<Text fontWeight="bold" as="span">
							Absolvent
						</Text>
					</Text>
				</LoginBox>

				<LoginBox
					icon={MdBusiness}
					onLogin={() =>
						push({
							pathname: '/login/company',
							state: externalState ?? state,
						})
					}
					onRegister={() => push('/registration/company')}
					redirectUrl="how-it-works/company"
				>
					<Text color={color}>
						Jsem{' '}
						<Text fontWeight="bold" as="span">
							Zaměstnavatel
						</Text>
					</Text>
				</LoginBox>
			</Grid>
		</ResponsivePadder>
	);
};
export default LoginOptions;
